import { motion } from 'motion/react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function VerifySuccessPage() {
  return (
    <div className='flex min-h-screen flex-col items-center justify-between bg-[#1e3a8a] p-6 text-white'>
      {/* Header */}
      <div className='w-full max-w-5xl pt-12'>
        {/* <div className='flex items-center gap-3'> */}
        <motion.div
          className='mr-2'
          initial={{ rotate: 0 }}
          animate={{ rotate: 360 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <img
            src={'/geo-rolodex-logo.png'}
            alt=''
            className='relative z-10 mx-auto h-6 w-52 md:h-7 md:w-52 lg:w-52'
            width={200}
            height={200}
          />
        </motion.div>
        {/* </div> */}
      </div>

      {/* Main Content */}
      <div className='flex w-full max-w-md flex-col items-center rounded-lg bg-white p-8 text-black shadow-lg'>
        <div className='relative mb-6'>
          {/* Outer circle with light green background */}
          <motion.div
            className='flex h-24 w-24 items-center justify-center rounded-full bg-green-100'
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              type: 'spring',
              stiffness: 260,
              damping: 20,
              delay: 0.3
            }}
          >
            {/* Inner circle with darker green background */}
            <motion.div
              className='flex h-16 w-16 items-center justify-center rounded-full bg-green-400'
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{
                type: 'spring',
                stiffness: 260,
                damping: 20,
                delay: 0.5
              }}
            >
              {/* Check mark animation */}
              <motion.div
                initial={{ pathLength: 0, opacity: 0 }}
                animate={{ pathLength: 1, opacity: 1 }}
                transition={{
                  duration: 0.8,
                  delay: 0.8,
                  ease: 'easeInOut'
                }}
              >
                <Check className='h-8 w-8 text-white' strokeWidth={3} />
              </motion.div>
            </motion.div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.2, duration: 0.5 }}
          className='text-center'
        >
          <h2 className='mb-2 text-2xl font-bold'>
            Awesome! Let&apos;s get started
          </h2>
          <p className='mb-8 text-gray-600'>
            Your account is ready to go - you can now access your workspace.
          </p>

          <Link to='/dashboard/map' className='block'>
            <motion.button
              className='w-full rounded-md bg-[#1e3a8a] px-4 py-3 font-medium text-white'
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
            >
              Begin
            </motion.button>
          </Link>
        </motion.div>
      </div>

      {/* Footer */}
      <div className='flex w-full max-w-5xl items-center justify-center py-8'>
        <div className='flex items-center'>
          
        </div>
      </div>
    </div>
  );
}